import './types';
import {
  AbstractAnalytic,
  type InitConfig as AbstractAnalyticInitConfig,
} from './AbstractAnalytic';
import { Events } from './Events';

export type { AbstractAnalyticInitConfig };
export { Events, AbstractAnalytic };
